import { RiDeleteBinFill } from 'react-icons/ri'
import { FaRegEdit } from 'react-icons/fa'
import { listaEstadosActivo } from "../../../app/constants/constants-selectores";
import { obtenerLabel } from "../../../shared/utils/funciones";
import { TablaSkeleton } from "../../../shared/ui/TablaSkeleton";

// Props presentacionales; la lógica vive en SedesPage. Los handlers se tipan
// laxo (`any`) por pragmatismo en la migración.
interface SedesTablaProps {
    isLoading: boolean;
    listaSedes: any[];
    buscar: boolean;
    mostrarBotonEditar: boolean;
    mostrarBotonEliminar: boolean;
    sedeEditar: (...args: any[]) => any;
    sedeEliminar: (...args: any[]) => any;
}

// Tabla de resultados de la página Sedes (sólo JSX presentacional).
export const SedesTabla = ({
    isLoading,
    listaSedes,
    buscar,
    mostrarBotonEditar,
    mostrarBotonEliminar,
    sedeEditar,
    sedeEliminar,
}: SedesTablaProps) => {
    return (
                <div className="tw-mt-2 tw-rounded-2xl tw-bg-white tw-p-3 tw-shadow-md tw-border tw-border-gray-100 tw-overflow-x-auto">
                    {/* Tabla de resultados */}
                    <table className="table table-hover tw-mb-0">
                        <thead className="table-light">
                            <tr>
                                <th scope="col" className="col text-center">Sede</th>
                                <th scope="col" className="col text-center">Compañía</th>
                                <th scope="col" className="col text-center">Entrega placa</th>
                                <th scope="col" className="col text-center">Estado</th>
                                {
                                    mostrarBotonEditar && (
                                        <th scope="col" className="col text-center">Editar</th>
                                    )
                                }
                                {
                                    mostrarBotonEliminar && (
                                        <th scope="col" className="col text-center">Eliminar</th>
                                    )
                                }

                            </tr>
                        </thead>
                        <tbody className={isLoading ? "" : "tabla-fade-in"}>

                            {
                                (isLoading && !listaSedes?.length) ? (
                                    <TablaSkeleton rows={6} cols={6} />

                                ) : (
                                    listaSedes?.length > 0 ? listaSedes.map((u) => (
                                        <tr key={u?.SedCod}>
                                            <td>{u?.SedDesc}</td>
                                            <td>{u?.TMCOMP10?.CompNom}</td>
                                            {/* Direccion de entrega de placas (TMSED10.SedDirecPlac). Puede estar
                                                vacia: en produccion hay sedes sin registrar. */}
                                            <td>{u?.SedDirecPlac}</td>
                                            <td>{obtenerLabel(listaEstadosActivo, u?.SedEst)}</td>
                                            {
                                                mostrarBotonEditar && (
                                                    <td><FaRegEdit size={23} cursor={'pointer'} className="color-iconos" onClick={() => sedeEditar(u?.SedCod, u?.CompCod)} /></td>
                                                )
                                            }
                                            {
                                                mostrarBotonEliminar && (
                                                    <td><RiDeleteBinFill size={23} cursor={'pointer'} color="#C0392B" onClick={() => sedeEliminar(u?.SedCod, u?.CompCod, u?.SedDesc)} /></td>
                                                )
                                            }
                                        </tr>
                                    )) :
                                        (
                                            (buscar) ? (
                                                <tr>
                                                    <td colSpan={100} className="text-center">No hay sedes</td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan={100} className="text-center">Realice una búsqueda</td>
                                                </tr>
                                            )
                                        )
                                )
                            }

                        </tbody>
                    </table>
                </div>
    )
}
